import { Link } from 'react-router-dom'
import { Container, Grid, Item } from '../common'

import items from '../data/images.json'

const Images = () => {
  return (
    <Container>
      <Grid>
        {Object.keys(items).map((id) => (
          <Link to={id && `/images/${id}`} key={id}>
            <Item item={items[id]} placeholder="/photo.svg" />
          </Link>
        ))}
      </Grid>
    </Container>
  )
}

export default Images
